import React from "react"
import { Container } from "react-bootstrap"
import {
  pageIncrement,
  pageDecrement,
  updateClickedNext,
  resetSelectDocument,
  controlLoading,
  controlDeclaration,
} from "../../redux/actions"
import {
  missingProvideDocumentProofOfClaimAlert,
  pleaseAgreeAlert,
  atLeastUploadOneFileAlert,
} from "../../services/sweetalertService"
import { useDispatch, batch } from "react-redux"
import SubmitClaim from "../pages/submitClaim"
import * as API from "../../services/httpService"
import Swal from "sweetalert2"
import * as Constants from "../../common/constants"

const FunctionalFooter = ({ pageNumber, uiData, claimData }) => {
  const dispatch = useDispatch()

  const { claimUploadListModel, proofDocuments, isEditUpload } = uiData

  const ClearDataWarning = Swal.mixin({
    customClass: {
      confirmButton: "swal-button--back",
      cancelButton: "swal-button--next",
      actions: "swal-footer",
    },
    buttonsStyling: false,
  })

  const checkMandatoryUploadDocument = () => {
    let mandatoryList = []

    mandatoryList = proofDocuments.filter(x => x.mandatory)

    let isUploaded = false

    //reversed for loop, because splice function inside loop
    for (let i = mandatoryList.length - 1; i >= 0; --i) {
      isUploaded = false
      claimUploadListModel.forEach(
        (currentCoverageItem, currentCoverageKey) => {
          if (
            !isUploaded &&
            mandatoryList[i].documentId === currentCoverageItem.documentId
          ) {
            mandatoryList.splice(i, 1)
            isUploaded = true
          }
        }
      )
    }
    //If mandatoryList is empty will pass mandatory file validation
    return mandatoryList.length < 1 ? true : false
  }

  const checkAtLeastUploadedOneFile = () => {
    return claimUploadListModel.length > 0 ? true : false
  }

  const nextPage = () => {
    //reset select document list everytime we click next
    // dispatch(resetSelectDocument())
    switch (pageNumber) {
      case Constants.policyInfoPageNumber:
        dispatch(updateClickedNext(pageNumber, true))
        break

      case Constants.requiredDocumentPageNumber:
        // if (
        //   !checkMandatoryUploadDocument() &&
        //   process.env.NODE_ENV !== "development"
        // ) {
        //   missingProvideDocumentProofOfClaimAlert()
        // } else {
          // if (
          //   checkAtLeastUploadedOneFile() ||
          //   process.env.NODE_ENV === "development"
          // ) {
            dispatch(resetSelectDocument())
            dispatch(pageIncrement())
          // } else {
          //   atLeastUploadOneFileAlert()
          // }
        // }
        break

      case Constants.lossDamageDetailsPageNumber:
        if (!uiData.showDeclaration) {
          dispatch(updateClickedNext(pageNumber, true))
        } else {
          if (!uiData.checkBoxStatus.isAgree) {
            pleaseAgreeAlert()
          } else {
            dispatch(controlLoading())
            SubmitClaim(dispatch, uiData, claimData)
          }
        }
        break
      default:
        batch(() => {
          dispatch(pageIncrement())
        })
    }
  }

  const previousPage = () => {
    switch (pageNumber) {
      case Constants.policyInfoPageNumber:
        break

      case Constants.requiredDocumentPageNumber:
        ClearDataWarning.fire({
          title:
            "Are you sure you want to go back to the first page? This will be remove all the data you have entered.",
          //icon: "warning",
          scrollbarPadding: false,
          showCancelButton: true,
          confirmButtonColor: "#ff3333",
          cancelButtonColor: "#fff",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          focusConfirm: false,
        }).then(result => {
          if (result.value) {
            let deleteMultipleFileArray = []

            claimUploadListModel.forEach((UploadedItem, UploadedKey) => {
              let deleteFileInfo = {}
              deleteFileInfo.fName = UploadedItem.fileName
              deleteFileInfo.folderName = uiData.folderName
              deleteMultipleFileArray.push(deleteFileInfo)
            })

            API.apiPostRequest(
              "/Claim/ClaimDocsMultipleDelete",
              deleteMultipleFileArray,
              null
            ).then(response => {})
            dispatch(pageDecrement())
          }
          return false
        })
        break

      default:
        if (uiData.showDeclaration) {
          dispatch(controlDeclaration())
        } else {
          dispatch(pageDecrement())
        }
    }
  }

  const hideBackButton = () => {
    //return true is hide the Back Button
    if (isEditUpload) return true

    switch (pageNumber) {
      case 1:
        return true
      default:
    }
  }

  const hideNextButton = () => {
    //return true is hide the Next Button
    switch (pageNumber) {
      default:
    }
  }

  return (
    <div
      className={
        "FooterClaimTravel container-fluid " +
        (pageNumber === Constants.submittedClaimPageNumber ? "hide" : "")
      }
    >
      <div className="row" style={{ margin: 0 }}>
        <Container className="FooterDiv">
          <div className={"BackBtnDiv " + (hideBackButton() ? "hide" : "")}>
            <button
              type="button"
              className="RectangleBtn bg-transparent text-center backBtnSummaryPage"
              onClick={() => previousPage()}
            >
              <i className="fa fa-angle-left" aria-hidden="true"></i> Back
            </button>
          </div>

          <div className={"NextBtnDiv " + (hideNextButton() ? "hide" : "")}>
            <button
              type="button"
              className="RectangleBtn text-center NextBtn"
              onClick={() => nextPage()}
            >
              {!uiData.showDeclaration ? "Next" : "Submit Claim"}
            </button>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default FunctionalFooter
